<div class="col-12">
  <div class="" style="font-size: 14px;">
    <div class="d-flex align-item-center justify-content-between">
      <span class="title">Application Access Status</span>
      <button class="btn button btn-add btn-primary" style="width: 127px;" (click)="revoke()">Revoke Access</button>
    </div>
    <mat-card class="mt-3">
      <div class="p-0 row">
        <div class="col-lg-2 col-md-6 px-2">
          <span>SSO</span>
          <mat-form-field appearance="outline" class=" w-100">
            <input matInput [(ngModel)]="sso" maxlength="50" placeholder="Enter sso">
            <mat-hint align="end">{{sso.length || 0}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-lg-3 col-md-6 px-2">
          <span>Supplier Name</span>
          <mat-form-field appearance="outline" class=" w-100">
            <input matInput [(ngModel)]="supplierName" maxlength="50" placeholder="Enter Supplier Name">
            <mat-hint align="end">{{supplierName.length || 0}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-lg-2 col-md-6 px-2">
          <span>GSL</span>
          <mat-form-field appearance="outline" class=" w-100">
            <input matInput [(ngModel)]="gsl" maxlength="50" placeholder="Enter GSL">
            <mat-hint align="end">{{gsl.length || 0}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-lg-3 col-md-6 px-2">
          <span>Application</span>
          <app-multiple-select [data]="apps" (result)="filterData('apps', $event)" [defaultAll]="true"></app-multiple-select>
        </div>
        <div class="d-flex align-items-center col-lg-2 col-md-12 px-2 justify-content-center">
          <button class="btn btn-add btn-outline-primary search" style="margin-top: 8px;"
          (click)="search()">Search</button>
        </div>
      </div>
    </mat-card>
  </div>
  
  <div class="mt-3">
    <table mat-table [dataSource]="dataSource" matSort class="w-100" (matSortChange)="sortData($event)">
    
      <!-- Application Column -->
      <ng-container matColumnDef="application">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;" > Application </th>
        <td mat-cell *matCellDef="let element"> {{element.application}} </td>
      </ng-container>
    
      <!-- SSO Column -->
      <ng-container matColumnDef="sso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> SSO </th>
        <td mat-cell *matCellDef="let element"> {{element.sso}} </td>
      </ng-container>
    
      <!-- Full Name Column -->
      <ng-container matColumnDef="full_Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> Full Name </th>
        <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
      </ng-container>
    
      <!-- GSL Column -->
      <ng-container matColumnDef="gsl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> GSL </th>
        <td mat-cell *matCellDef="let element"> {{element.gslNumber}} </td>
      </ng-container>
  
      <!-- Supplier Name Column -->
      <ng-container matColumnDef="supplier_Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> Supplier Name </th>
        <td mat-cell *matCellDef="let element"> {{element.supplierName}} </td>
      </ng-container>
  
      <!-- Last Upload Column -->
      <ng-container matColumnDef="last_upload">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;"> Last Upload </th>
        <td mat-cell *matCellDef="let element"> {{element.lastUpload}} </td>
      </ng-container>
  
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="width: 10%;"> Action </th>
        <td mat-cell *matCellDef="let element" class="py-2">
          <button class="btn btn-add button btn-primary" style="width: 135px;" (click)="revoke(element.id)" *ngIf="element.application === 'RACES iSupplier'">Revoke Access</button>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
      [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
  </div>
</div>

